import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialState } from './states';

const liveEndSlice = createSlice({
    name: 'liveEnd',
    initialState,
    reducers: {
        setLiveTimeUp(state, action: PayloadAction<boolean>) {
            state.isLiveTimeUp = action.payload;
        },
        setReservationCartCount(state, action: PayloadAction<number>) {
            state.reservationCartCount = action.payload;
        },
    },
});

export const { setLiveTimeUp, setReservationCartCount } = liveEndSlice.actions;
export default liveEndSlice.reducer;
